import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'loyaltic-how-to',
    templateUrl: './how-to.component.html',
    styleUrls: ['./how-to.component.scss'],
    standalone: false
})
export class HowToComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
